import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { TMeasurementList } from 'shared/types'
import { api } from '..'

export const getMeasurementsByDeviceId = (
  deviceId: string,
  params?: Record<string, string>,
) =>
  api
    .get<TMeasurementList>('/v1/measurements', {
      params: { deviceId, ...params },
    })
    .then(({ data }) => data)

export const measurementListQueryByDevice = (
  deviceId: string,
  params?: Record<string, string>,
) => ({
  queryFn: () => getMeasurementsByDeviceId(deviceId, params),
  queryKey: ['measurements', deviceId, params],
})

export const useGetMeasurementsByDevice = (deviceId?: string) => {
  if (!deviceId) throw new Error('Missing deviceId')
  const [urlParams] = useSearchParams()
  const params = Object.fromEntries(urlParams.entries())

  const query = measurementListQueryByDevice(deviceId, params)

  return useQuery({
    ...query,
    keepPreviousData: true,
    useErrorBoundary: false,
  })
}
